// extracted by mini-css-extract-plugin
export default {"pagination":"Paging_pagination__lvk6j","active":"Paging_active__6q4zi","disabled-link":"Paging_disabled-link__rCjde"};